"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = _interopRequireDefault(require("../base"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var StiloFormTitle = function StiloFormTitle(_ref) {
  var id = _ref.id,
      label = _ref.label;
  return /*#__PURE__*/_react["default"].createElement(_base["default"], {
    controlClassName: "title",
    id: id,
    label: label
  });
};

StiloFormTitle.propTypes = {
  label: _propTypes["default"].node,
  id: _propTypes["default"].string
};
var _default = StiloFormTitle;
exports["default"] = _default;
//# sourceMappingURL=bootstrap.js.map